import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { stepsData } from '../data/mock';

const HowItWorksSection = () => {
  return (
    <section className="section" id="how-it-works">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block text-sm font-semibold text-[#FF6B35] uppercase tracking-wider mb-4">
            How It Works
          </span>
          <h2 className="heading-1 mb-4">
            From Idea to Launch in{' '}
            <span className="gradient-text">3 Simple Plays</span>
          </h2>
          <p className="body-large">
            No tech skills required. We handle everything so you can focus on what you do best.
          </p>
        </div>
        
        <div className="relative">
          {/* Connection line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-[#FF6B35]/30 to-transparent -translate-y-1/2" />
          
          <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
            {stepsData.map((step, index) => (
              <div 
                key={step.step}
                className="relative bg-[#12121A] rounded-2xl p-8 border border-[#2A2A35] hover:border-[#FF6B35]/30 transition-all animate-fade-in-up"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                {/* Step number */}
                <div className="step-number mb-6">
                  {step.step}
                </div>
                
                <h3 className="text-xl font-semibold text-white mb-3">
                  {step.title}
                </h3>
                <p className="body-medium text-[#6B6B78] mb-6">
                  {step.description}
                </p>
                
                {/* Arrow to next step */}
                {index < stepsData.length - 1 && (
                  <div className="hidden md:flex absolute -right-6 top-1/2 -translate-y-1/2 w-12 h-12 rounded-xl bg-gradient-to-br from-[#FF6B35] to-[#FF8555] items-center justify-center z-10">
                    <ArrowRight size={20} className="text-black" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        
        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-[#6B6B78] mb-6">
            Ready to make the winning play?
          </p>
          <Link 
            to="/contact"
            className="btn-primary"
          >
            Get Your Free Quote
            <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
